import React, { Component } from 'react';
import PropTypes from 'prop-types';

class HeaderBalanceSection extends Component {
  render() {
    const { userBalance } = this.props;
    const { t } = this.context;

    return (
      <div className="header-container__right-part__item col-md-3 col-xs-12 pull-right">
        <p className="text">{t('HEADER.ACCOUNT_BALANCE')}</p>
        <p className="value">
          <span className="glyphicon glyphicon-briefcase" />
          <span className="balance">${userBalance ? parseFloat(userBalance.balance || 0).toFixed(2) : ''}</span>
        </p>
      </div>
    );
  }
}

HeaderBalanceSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default HeaderBalanceSection;



// WEBPACK FOOTER //
// ./src/app/main/layout/components/header-balance-section.js